import React, { useMemo } from 'react';
import {
  FaUserTie, FaFileAlt
} from 'react-icons/fa';
import GenericCrudPage from '../components/GenericCrudPage';

const StaffTypePage = () => {
  const crudConfig = {
    baseUrl: process.env.REACT_APP_BASE_URL || '',
    endpoints: {
      fetch: '/master/getStaffType',
      save: '/master/saveStaffType',
      update: '/master/updateStaffType',
      delete: '/master/deleteStaffType'
    },
    entityName: 'Staff Type',
    initialFormState: {
      exName: '',
      exDescription: '',
    },
    validateForm: (form) => {
      const errors = {};
      if (!form.exName) errors.exName = 'Staff Type Name is required.';
      return errors;
    }
  };

  const formFields = useMemo(() => [
    { name: 'exName', label: 'Staff Type Name', icon: FaUserTie, required: true },
    { name: 'exDescription', label: 'Description', icon: FaFileAlt, as: 'textarea', rows: 3, fullWidth: true },
  ], []);

  const tableColumns = [
    { key: 'exName', label: 'Name', sortable: true },
    { key: 'exDescription', label: 'Description' },
  ];

  const csvHeaders = [
    { key: 'exName', label: 'Name' },
    { key: 'exDescription', label: 'Description' },
    { key: 'exIsActive', label: 'Status', render: () => 'Active' }
  ];

  const transformPayload = (form, editId, userId) => {
    return {
      id: editId,
      exName: form.exName,
      exDescription: form.exDescription,
      exIsActive: 1, // Always set to active (1)
      user: userId,
    };
  };

  const transformToForm = (item) => ({
    exName: item.exName || '',
    exDescription: item.exDescription || '',
  });

  const getViewFields = (item) => item ? [
    { label: 'Staff Type Name', value: item.exName, icon: FaUserTie },
    { label: 'Status', value: 'Active', icon: FaUserTie },
    { label: 'Description', value: item.exDescription, icon: FaFileAlt, fullWidth: true },
  ] : [];

  return (
    <GenericCrudPage
      title="Staff Type"
      config={crudConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      csvHeaders={csvHeaders}
      csvFilename="staff_types.csv"
      transformPayload={transformPayload}
      transformToForm={transformToForm}
      getViewFields={getViewFields}
      emptyIcon={FaUserTie}
      searchPlaceholder="Search staff types..."
    />
  );
};

export default StaffTypePage;
